import * as React from 'react'
import Link from 'next/link'

import { useModal } from 'react-modal-hook'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import { useSupport } from 'components/hooks/use-support'
import { useUser } from 'components/hooks/state'
import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import WelcomeModal from 'components/modals/welcome-modal'
import Text from 'components/atomic/atoms/text'
import Logo from 'components/atomic/atoms/logo'
import Routes from 'utils/routes'

const Footer = () => {
    const [showWelcomeModal, hideWelcomeModal] = useModal(() => <WelcomeModal open={true} onClose={hideWelcomeModal} />)
    const { toggleChatWidget } = useSupport()
    const { t }: I18n = useTranslation()
    const { user } = useUser()

    const columns = [
        {
            title: 'Prodotto',
            items: [
                ...(!user
                    ? [
                          {
                              text: 'Accedi',
                              to: Routes.SignIn,
                          },
                          {
                              text: 'Registrati',
                              to: Routes.SignUp,
                          },
                      ]
                    : []),
                ...(user?.subscription_status !== 'ACTIVE'
                    ? [
                          {
                              text: 'Diventa un PRO ',
                              to: Routes.Pricing,
                          },
                      ]
                    : []),
                // {
                //     text: 'Come funziona',
                //     to: Routes.Home,
                // },
                {
                    text: 'Supporters ✨',
                    to: Routes.Supporters,
                },
                {
                    text: 'Come funziona?',
                    do: showWelcomeModal,
                },
                {
                    text: 'Trova il tuo percorso',
                    to: Routes.SortingQuiz,
                },
                {
                    text: 'Piani e prezzi',
                    to: Routes.Pricing,
                },
            ],
        },
        {
            title: 'Argomenti',
            items: [
                {
                    text: 'Web development',
                    to: Routes.Category('web-development'),
                },
                {
                    text: 'Game Development',
                    to: Routes.Category('game-development'),
                },
                {
                    text: 'Machine learning',
                    to: Routes.Category('machine-learning'),
                },
                {
                    text: 'Cybersecurity',
                    to: Routes.Category('cybersecurity'),
                },
                {
                    text: 'Data science',
                    to: Routes.Category('data-science'),
                },
                {
                    text: 'Mobile development',
                    to: Routes.Category('mobile-development'),
                },
            ],
        },
        {
            title: 'Linguaggi',
            items: [
                {
                    text: 'HTML & CSS',
                    to: Routes.Category('html-css'),
                },
                {
                    text: 'Python',
                    to: Routes.Category('python'),
                },
                {
                    text: 'JavaScript',
                    to: Routes.Category('javascript'),
                },
                {
                    text: 'SQL',
                    to: Routes.Category('sql'),
                },
                {
                    text: 'Swift',
                    to: Routes.Category('swift'),
                },
                {
                    text: 'Java',
                    to: Routes.Category('java'),
                },
            ],
        },
        {
            title: 'Supporto',
            items: [
                {
                    text: 'Privacy policy',
                    to: 'https://www.iubenda.com/privacy-policy/47485235',
                },
                {
                    text: 'Cookie policy',
                    to: 'https://www.iubenda.com/privacy-policy/47485235/cookie-policy',
                },
                {
                    text: 'Terms of use',
                    to: 'https://www.iubenda.com/termini-e-condizioni/47485235',
                },
                {
                    text: 'Contatto email',
                    to: 'mailto:matteo@devv.it', // TODO: add support email
                },
                {
                    text: 'Parla con il supporto',
                    do: toggleChatWidget,
                },
            ],
        },
    ]

    return (
        <Box component="footer" sx={{ borderTop: (theme) => `1px solid ${theme.palette.divider}` }}>
            <ResponsiveContainer maxWidth="xl">
                <Box sx={{ py: { xs: 4, md: 6 } }}>
                    <Grid container spacing={{ xs: 4, md: 6 }}>
                        <Grid item xs={12} md={4}>
                            <Stack direction="column" spacing={2}>
                                <Logo clickable={true} link={Routes.Home} />
                                <Text variant="subtitle2">{t('common:footer.description')}</Text>
                                <Text variant="caption">
                                    {t('common:footer.copywrite', { year: new Date().getFullYear() })}
                                </Text>
                            </Stack>
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Grid container spacing={4} justifyContent="space-evenly">
                                {columns.map((column) => (
                                    <Grid item xs={6} md={3} key={column.title}>
                                        <Text variant="h6" color="text.primary" gutterBottom>
                                            {column.title}
                                        </Text>
                                        <Stack direction="column" spacing={2} mt={3}>
                                            {column.items.map((item) =>
                                                item.to ? (
                                                    <Link href={item.to} key={item.text} passHref>
                                                        <a>
                                                            <Text variant="subtitle2">{item.text}</Text>
                                                        </a>
                                                    </Link>
                                                ) : (
                                                    <Text
                                                        variant="subtitle2"
                                                        onClick={item.do}
                                                        key={item.text}
                                                        sx={{ cursor: 'pointer' }}>
                                                        {item.text}
                                                    </Text>
                                                ),
                                            )}
                                        </Stack>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </ResponsiveContainer>
        </Box>
    )
}

export default Footer
